import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Styles from './Styles';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import ListItemText from '@material-ui/core/ListItemText';

import AutoComplete from '../../../GeneralUI/AutoComplete';
import { saveCustom } from './../../../../Actions/General'
import { errorSetter } from '../../../../Libs';
import Utils from '../../../../Libs/utils';


class Detalleusuarioclientes extends Component {

  constructor(props) {
    super(props);
    this.setErrors = errorSetter.setErrors.bind(this);
  }

  state = {
    errorForm: false,
    errorMessage: '',
    fields: {
      Cliente: { 'value': null, 'key': null,'visible':true }
    },
    formValidations: {
      view: ['Cliente']
    },
    formErrors: {
      Cliente: {}
    }
  };


  componentDidMount = () => {
    console.log(this.props.editData);
    if (this.props.editData) {
      this.fillForm(this.props.editData, this.props.setIndex)
    }
    if (this.props.datosHeader) {
      this.setState(this.props.datosHeader);
    }
    console.log(this.props.datosHeader);
  }

  fillForm = (data, index) => {
    let { fields } = this.state;

    fields["Cliente"] = ({ 'value': data[index].Cliente.value, 'key': data[index].Cliente.key,'visible':true });
    
    this.setState({ fields });
  }

  handleChange = (event) => {
    let { fields } = this.state; this.setState({ fields });
    fields[event.target.id].value= event.target.value;
    fields[event.target.id].key= event.target.hasOwnProperty('text') ? event.target.text : event.target.value
    this.setState({ fields });
  }

  validateLogicaForm = async () => {
  }

  setDataValidation = (errorForm, errorMessage) => {
    this.setState({ errorForm: errorForm, errorMessage: errorMessage });
  }

  setData = async () => {
    const validations = errorSetter.validateFormFields(this.state.fields, this.state.formValidations);
    this.setState({ formErrors: validations.errors });
    if (validations.isValid && !this.state.errorForm) {
      this.props.setData(this.state.fields, this.props.editData ? this.props.setIndex : null);
    }
  }

  render = () => {
    return (
      <Paper elevation={1} className={this.props.classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>
          <Grid container direction='row' className={this.props.classes.paperGridTitle}>
            <List component="nav">
              <ListItem>
                <ListItemText primary="Permisos X Cliente" classes={{ primary: this.props.classes.titlelabelformwhite }} />
              </ListItem>
              {(this.state.errorForm) ?
                <ListItem>
                  <ListItemText primary={this.state.errorMessage} classes={{ primary: this.props.classes.titlelabelerrorform }} />
                </ListItem> : ''
              }
            </List>
          </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} className={this.props.classes.gridForm}>
              <AutoComplete
                id="Cliente"
                tableName='cliente'
                fields={['cliente_codigo','cliente_razon_social']}
                isView={true}
                aliases={[{ value: 'ID', size: 1 }, { value: 'Nombre', size: 11 }]}
                size='xx'
                primaryField='cliente_codigo'
                searchField='cliente_razon_social'
                placeHolder='Seleccionar Cliente'
                onSelect={this.handleChange}
                value={this.state.fields["Cliente"].value}
                error={this.state.formErrors['Cliente'].error}
                helperText={this.state.formErrors['Cliente'].errorMessage}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} >
            <Grid item xs={3} className={this.props.classes.gridForm}>

              <Button
                color='primary'
                onClick={this.setData}
              >
                Adicionar
              </Button>

            </Grid>
          </Grid>


        </form>
      </Paper>
    );
  }
}

export default withStyles(Styles, { withTheme: true })(Detalleusuarioclientes);